import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ClosingSalePage } from './closing-sale';

@NgModule({
  declarations: [
    ClosingSalePage,
  ],
  imports: [
    IonicPageModule.forChild(ClosingSalePage),
  ],
})
export class ClosingSalePageModule {}



// WEBPACK FOOTER //
// ./src/pages/closing-sale/closing-sale.module.ts